import React from 'react'

import Field from '../../../../components/Form/Field'

import { ageYearsList } from '../../../../constants/selectLists/ageYearsList'
import { AGE_MAX, AGE_MIN } from '../../../Facebook/fields'

const FacebookAgesRange = ({ formik }) => {
  const { values } = formik

  const minYearsList = ageYearsList.filter(year => Number(year.value) < values[AGE_MAX])
  const maxYearsList = ageYearsList.filter(year => Number(year.value) > values[AGE_MIN])

  return (
    <>
      <Field placeholder="Min age" formik={formik} name={AGE_MIN} options={minYearsList} />
      <Field placeholder="Max age" formik={formik} name={AGE_MAX} options={maxYearsList} />
    </>
  )
}

export default FacebookAgesRange
